export default __webpack_public_path__ + "static/media/use-primary-color.96717527.png";